import LoginForm from "../pages/login";
import ForgotForm from "../pages/forgotPassword";
import RegisterForm from "../pages/register";
import DashboardStarts from "../pages/stats";
import TemplatesPage from "../pages/templates";
import ClientsPage from "../pages/clients";
import ClientProfilePage from "../pages/clientProfile";
import ClientProfileOverview from "../pages/client-profile/clientProfileOverview";
import ClientProfileReports from "../pages/client-profile/clientProfileReport";
import ClientProfileContacts from "../pages/client-profile/clientProfileContact";
import ClientProfileConfiguration from "../pages/client-profile/clientProfileConfiguration";
import ClientProfileManageUsers from "../pages/client-profile/clientProfileManageUsers";
import ClientProfileAddUser from "../pages/client-profile/clientProfileAddUser";
import ClientProfileManageTpColumn from "../pages/client-profile/clientProfileManageTpColumn";
import ClientProfileEditCompanyKeyword from "../pages/client-profile/clientProfileEditCompanyKeyword";
import ClientProfileManageCustomAttributes from "../pages/client-profile/clientProfileManageCustomAttributes";
import Identifiers from "../pages/client-profile/clientProfileIdentifiers";
import ClientProfileManageCategory from "../pages/client-profile/clientProfileManageCategory";
import ClientProfileRemediation from "../pages/client-profile/clientProfileRemediation";
import ClientProfileForms from "../pages/client-profile/clientProfileForms";
import ClientProfileEdd from "../pages/client-profile/clientProfileEdd";
import ClientProfileVouchers from "../pages/client-profile/clientProfileVouchers";
import ClientProfileTrainingCourses from "../pages/client-profile/clientProfileTrainingCourses";
import ClientProfileTrainingExams from "../pages/client-profile/clientProfileTrainingExams";
import CreateExam from "../pages/client-profile/create-exam";
import ClientProfileTrainingExamQuestions from "../pages/client-profile/clientProfileTrainingExamQuestions";
import ClientProfileWorkflowTypes from "../pages/client-profile/clientProfileWorkflowTypes";
import ClientProfileWorkflowStages from "../pages/client-profile/clientProfileWorkflowStages";
import ClientProfileWorkflowForms from "../pages/client-profile/clientProfileWorkflowForms";
import ClientProfileThirdParties from "../pages/client-profile/clientProfileThirdParties";
import MyTPP from "../pages/mytpp";
import MyTPPQuestionnaires from "../pages/mytpp-questionnaires";
import MyTPPTraining from "../pages/mytpp-training";
import MyTPPTrainingWithTest from "../pages/mytpp-training-test";
import MyTPPCertifications from "../pages/mytpp-certifications";
import MyTPPAnnualCertifications from "../pages/mytpp-annual-certifications";
import Reports from "../pages/reports";
import AddExamsPage from "../pages/add-exams";
import AddExamQuestionPage from "../pages/add-exam-questions";
import ClientsVueContainer from "../containers/ClientsVueContainer";
import EmployeePage from "../pages/employeePage";
import AddTrainingCoursesPage from "../pages/add-training-courses";
import ThirdPartyEntityPage from "../pages/thirdPartyEntityPage";
import ThirdpartyStatsPage from "../pages/thirdpartyStatsPage";
import UserFormPage from "../pages/user-form";
import UserTrainingPage from "../pages/user-training";
import UserTrainingTestPage from "../pages/user-test-training.vue";
import UserExamPage from "../pages/user-exam";
import PreviewPage from "../pages/preview";
import FormPage from "../pages/form";
import FormConfigurationContainer from "../containers/FormConfigurationContainer";
import FormIntroContainer from "../containers/FormIntroContainer";
import FormDetailsContainer from "../containers/FormDetailsContainer";
import FormBuilderContainer from "../containers/FormBuilderContainer";
import FormCssContainer from "../containers/FormCssContainer";
import FormJsonContainer from "../containers/FormJsonContainer";
import FormJsContainer from "../containers/FormJsContainer";
import FormSettingsContainer from "../containers/FormSettingsContainer.vue";

export default [
    {
        path: '/login',
        name: 'login',
        component: LoginForm,
        meta: { jwtRequiresAuth: false }

    },
    {
        path: '/',
        name: 'home',
        props: true,
        component: TemplatesPage,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userGroupId == 16) {
                next('/dashboard')
            } else {
                next();
            }
        }
    },
    {
        path: '/home',
        name: 'home',
        component: TemplatesPage,
        props: true,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userGroupId == 16) {
                next('/dashboard')
            } else {
                next();
            }
        }
    },
    {
        path: '/forgot',
        name: 'forgot-password',
        component: ForgotForm,
        meta: { requiresAuth: false }

    },
    {
        path: '/create-profile',
        name: 'createProfile',
        component: RegisterForm,
        meta: { requiresAuth: true }
    },
    {
        path: '/profile',
        name: 'updateProfile',
        component: RegisterForm,
        meta: { requiresAuth: true }
    },
    {
        path: '/stats',
        name: 'stats',
        component: DashboardStarts,
        meta: { requiresAuth: true }

    },

    {
        path: '/templates',
        name: 'templates',
        component: TemplatesPage,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userGroupId == 16) {
                next('/dashboard')
            } else {
                next();
            }
        }
    },
    {
        path: '/clients',
        name: 'ClientsPage',
        component: ClientsPage,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userType == 1 || userType == 2) {
                next();
            } else {
                next('/dashboard');
            }
        }
    },
    {
        path: '/client-profile/:id',
        name: 'clientProfilePage',
        props: true,
        component: ClientProfilePage,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userType == 1 || userType == 2) {
                next();
            } else {
                next('/dashboard');
            }
        },
        children: [
            {
                name: 'overview',
                path: 'overview',
                component: ClientProfileOverview,
                props: true,
                meta: { requiresAuth: true }
            },
            {
                name: 'reports',
                path: 'reports',
                component: ClientProfileReports,
                props: true,
                meta: { requiresAuth: true }
            },
            {
                name: 'contacts',
                path: 'contacts',
                component: ClientProfileContacts,
                props: true,
                meta: { requiresAuth: true }
            },
            {
                name: 'configuration',
                path: 'configuration',
                component: ClientProfileConfiguration,
                props: true,
                meta: { requiresAuth: true }
            },
            {
                name: 'manageUsers',
                path: 'manage-users',
                component: ClientProfileManageUsers,
                props: true,
                meta: { requiresAuth: true }
            },
            {
                name: 'addUser',
                path: 'add-user',
                component: ClientProfileAddUser,
                props: true,
                meta: { requiresAuth: true }
            },
            {
                name: 'manageTpColumn',
                path: 'manage-tp-user',
                component: ClientProfileManageTpColumn,
                props: true,
                meta: { requiresAuth: true }
            },
            {
                name: 'addCompanyKeywords',
                path: 'add-company-keywords',
                component: ClientProfileEditCompanyKeyword,
                props: true,
                meta: { requiresAuth: true }
            },
            {
                name: 'manageCustomAttributes',
                path: 'tpi-custom-attributes',
                component: ClientProfileManageCustomAttributes,
                props: true,
                meta: { requiresAuth: true }
            },
            {
                name: 'Identifiers',
                path: 'identifiers',
                component: Identifiers,
                meta: { requiresAuth: true }
            },
            {
                name: 'manageCategory',
                path: 'manage-category',
                component: ClientProfileManageCategory,
                props: true,
                meta: { requiresAuth: true }
            },
            {
                name: 'remediation',
                path: 'remediation',
                props: true,
                component: ClientProfileRemediation,
                meta: { requiresAuth: true }
            },
            {
                name: 'forms',
                path: 'forms',
                props: true,
                component: ClientProfileForms,
                meta: { requiresAuth: true }
            },
            {
                name: 'edd',
                path: 'edd',
                props: true,
                component: ClientProfileEdd,
                meta: { requiresAuth: true }
            },
            {
                name: 'vouchers',
                path: 'vouchers',
                props: true,
                component: ClientProfileVouchers,
                meta: { requiresAuth: true }
            },
            {
                name: 'training-courses',
                path: 'training/courses',
                props: true,
                component: ClientProfileTrainingCourses,
                meta: { requiresAuth: true }
            },
            {
                name: 'training-exams',
                path: 'training/exams',
                props: true,
                component: ClientProfileTrainingExams,
                meta: { requiresAuth: true }
            },
            {
                name: 'training-exams',
                path: 'training/exams',
                props: true,
                component: ClientProfileTrainingExams,
                meta: { requiresAuth: true }
            },
            {
                name: 'training-tests',
                path: 'training/create-exam',
                props: true,
                component: CreateExam,
                meta: { requiresAuth: true }
            },
            {
                name: 'training-exam-questions',
                path: 'training/exam-questions',
                props: true,
                component: ClientProfileTrainingExamQuestions,
                meta: { requiresAuth: true }
            },

            {
                name: 'workflowtypes',
                path: 'workflow/types',
                props: true,
                component: ClientProfileWorkflowTypes,
                meta: { requiresAuth: true }
            },
            {
                name: 'workflowstages',
                path: 'workflow/stages',
                props: true,
                component: ClientProfileWorkflowStages,
                meta: { requiresAuth: true }
            },
            {
                name: 'workflowforms',
                path: 'workflow/forms',
                props: true,
                component: ClientProfileWorkflowForms,
                meta: { requiresAuth: true }
            },
            {
                name: 'thirdParties',
                path: 'thirdparties',
                props: true,
                component: ClientProfileThirdParties,
                meta: { requiresAuth: true }
            },



        ],
        meta: { requiresAuth: true }
    },
    {

        path: '/mytpp',
        name: 'mytpp',
        component: MyTPP,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userGroupId == 16) {
                next('/dashboard')
            } else {
                next();
            }
        }
    },
    {

        path: '/dashboard',
        name: 'dashboard-third-party',
        component: MyTPP,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            let registrationStatus = localStorage.getItem("registrationStatus");
            let userType = localStorage.getItem("userType");
            if (userGroupId == 16 && registrationStatus == 0) {
                next('/create-profile')
            } else {
                next();
            }
        }
    },
    {

        path: '/my-questionnaires',
        name: 'mytppquestionnaires',
        component: MyTPPQuestionnaires,
        meta: { requiresAuth: true }
    },
    {

        path: '/my-training',
        name: 'mytpptraining',
        component: MyTPPTraining,
        meta: { requiresAuth: true }
    },
    {

        path: '/training-tests-list',
        name: 'myTPPTrainingWithTest',
        component: MyTPPTrainingWithTest,
        meta: { requiresAuth: true }
    },
    

    {

        path: '/my-certifications',
        name: 'mytppcertifications',
        component: MyTPPCertifications,
        meta: { requiresAuth: true }
    },

    {

        path: '/annual-certifications',
        name: 'annualtppcertifications',
        component: MyTPPAnnualCertifications,
        meta: { requiresAuth: true }
    },
    
    {

        path: '/reports',
        name: 'reports',
        component: Reports,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userType == 1 || userType == 2) {
                next();
            } else {
                next('/dashboard');
            }
        }
    },
    {

        path: '/add-exams',
        name: 'addexams',
        component: AddExamsPage,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userType == 1 || userType == 2) {
                next();
            } else {
                next('/dashboard');
            }
        }
    },
    {

        path: '/add-exam-questions',
        name: 'addexamquestions',
        component: AddExamQuestionPage,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userType == 1 || userType == 2) {
                next();
            } else {
                next('/dashboard');
            }
        }
    },
    {
        path: '/employee-page',
        name: 'EmployeePage',
        component: EmployeePage,
        meta: { requiresAuth: true }
    },
    {

        path: '/add-training-courses/:companyId',
        name: 'addtrainingcourses',
        component: AddTrainingCoursesPage,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userType == 1 || userType == 2) {
                next();
            } else {
                next('/dashboard');
            }
        }
    },
    {

        path: '/thirdparty/profile/:thirdPartyId/:companyId',
        name: 'ThirdPartyEntityPage',
        component: ThirdPartyEntityPage,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userType == 1 || userType == 2) {
                next();
            } else {
                next('/dashboard');
            }
        }
    },
    {

        path: '/management-reports/:id',
        name: 'ThirdpartyStatsPage',
        component: ThirdpartyStatsPage,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userType == 1 || userType == 2) {
                next();
            } else {
                next('/dashboard');
            }
        }
    },
    {

        path: '/user-form',
        name: 'userform',
        props: true,
        component: UserFormPage,
        meta: {
            requiresAuth: true,
            // denyUserGroupId: 16
        },
        beforeEnter: (to, from, next) => {
            let activeTaskStatus = localStorage.getItem("activeTaskStatus");
            if (from.name && from.name == 'mytppquestionnaires' || activeTaskStatus) {
                next()
            } else {
                next('/dashboard');
            }
        }
    },

    {

        path: '/user-training',
        name: 'userTraining',
        props: true,
        component: UserTrainingPage,
        meta: {
            requiresAuth: true,
            // denyUserGroupId: 16
        },
        beforeEnter: (to, from, next) => {
            let activeTaskStatus = localStorage.getItem("activeTaskStatus");

            if (from.name && from.name == 'mytpptraining' || activeTaskStatus) {
                next()
            } else {
                next('/dashboard');
            }
        }
    },

    {

        path: '/user-training-test',
        name: 'userTrainingTest',
        props: true,
        component: UserTrainingTestPage,
        meta: {
            requiresAuth: true,
            // denyUserGroupId: 16
        },
        beforeEnter: (to, from, next) => {
            let activeTaskStatus = localStorage.getItem("activeTaskStatus");

            if (from.name && from.name == 'myTPPTrainingWithTest' || activeTaskStatus) {
                next()
            } else {
                next('/dashboard');
            }
        }
    },

    

    {

        path: '/user-exam',
        name: 'userexam',
        props: true,
        component: UserExamPage,
        meta: { requiresAuth: true },
        beforeEnter: (to, from, next) => {
            let activeTaskStatus = localStorage.getItem("activeTaskStatus");

            if (from.name && from.name == 'mytppcertifications' || activeTaskStatus) {
                next()
            } else {
                next('/dashboard');
            }
        }
    },
    {
        path: '/preview',
        name: 'preview',
        props: true,
        component: PreviewPage,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userType == 1 || userType == 2) {
                next();
            } else {
                next('/dashboard');
            }
        }
    },
    {
        path: '/form',
        name: 'form',
        component: FormPage,
        props: true,
        meta: { requiresAuth: true, isAdmin: true },
        beforeEnter: (to, from, next) => {
            let userType = localStorage.getItem("userType");
            if (userGroupId == 16) {
                next('/dashboard')
            } else {
                next();
            }
        },
        children: [
            {
                path: 'configuration',
                name: 'config',
                props: true,
                component: FormConfigurationContainer,
                meta: { requiresAuth: true, isAdmin: true }
            },
            {
                path: 'intro',
                name: 'intro',
                props: true,
                component: FormIntroContainer,
                meta: { requiresAuth: true, isAdmin: true }
            },
            {
                path: 'details',
                name: 'details',
                props: true,
                component: FormDetailsContainer,
                meta: { requiresAuth: true, isAdmin: true }
            },
            {
                path: 'builder',
                name: 'builder',
                props: true,
                component: FormBuilderContainer,
                meta: { requiresAuth: true, isAdmin: true }
            },
            {
                path: 'css',
                name: 'css',
                props: true,
                component: FormCssContainer,
                meta: { requiresAuth: true, isAdmin: true }
            },
            {
                path: 'json',
                name: 'json',
                props: true,
                component: FormJsonContainer,
                meta: { requiresAuth: true, isAdmin: true }
            },
            {
                path: 'js',
                name: 'js',
                props: true,
                component: FormJsContainer,
                meta: { requiresAuth: true, isAdmin: true }
            },
            {
                path: 'settings',
                name: 'settings',
                props: true,
                component: FormSettingsContainer,
                meta: { requiresAuth: true, isAdmin: true }
            }
        ]
    }

]
